import axios from "axios";
import config from "../config";

export const getDistributors = async () => {
    const url = `${config.apiUrl}/api/distributors`;
    const {
        data: { results }
    } = await axios(url, {
        withCredentials: true
    });
    return results;
};
